<template>
    <b-card v-if="place">
        <b-card-body>
            <b-row>
                <b-col>
                    <b-card>
                        <b-button :pressed="incStreet" variant="light" @click="toggleInc('street')"
                            title="Sök på adressen">{{ place.street }}</b-button><br>
                        <b-button :pressed="incPostcode" variant="light" @click="toggleInc('postcode')">{{ place.postCode
                        }}</b-button>
                        <b-button :pressed="incCity" variant="light" @click="toggleInc('city')">{{ place.city
                        }}</b-button><br>
                    </b-card>
                    <b-input v-model="searchFor" placeholder="Sök..."></b-input>
                    <b-row>
                        <b-col cols="3">
                            <b-button @click="search()">Sök </b-button>
                        </b-col>
                        <b-col cols="1">
                            <div>
                                <b-spinner variant="primary" v-if="isBusy" label="Söker..."></b-spinner>
                            </div>
                        </b-col>
                        <b-col>
                            <b-button size="sm" variant="light" title="Hämta från Google Maps" @click="openGoogle()">
                                <img src="../../assets/googlemaps.png">
                            </b-button>
                            <b-button size="sm" variant="light" title="Klistra in koordinater du klippt ut från Google Maps"
                                @click="pasteFromClipboard">
                                <b-icon-map></b-icon-map> Klistra in från Google Maps
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row v-if="placeList && placeList.length > 0">
                        <b-row v-for="(p, i) in placeList" :key="i">
                            <b-col>
                                <b-button block variant="outline-secondary" @click="setGeo(p.geoX, p.geoY)"
                                    @mouseover="highlightOnMap(p)">
                                    <b-badge>{{ i + 1 }}</b-badge> {{ p.text }}</b-button>
                            </b-col>
                        </b-row>
                    </b-row>
                </b-col>
                <b-col>
                    <div>
                        <iframe ref="geocodeiframe" src="/map/index.html" width="100%" height="1200px"></iframe>
                    </div>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import Settings from "../../lib/settings";
import { Api } from "../../lib/api";
const api = new Api();

let timer;


export default {
    name: 'geocode',
    props: { place: Object },
    created() {
        if (this.place) {
            this.searchFor = this.getDefaultSearchFor();
            this.search();
        }
    },
    mounted() {
        // Listen for messages from the iframe
        window.addEventListener('message', this.handleMessage);
    },
    beforeDestroy() {
        // Clean up the event listener when the component is destroyed
        window.removeEventListener('message', this.handleMessage);
    },
    data() {
        return {
            searchFor: null,
            placeList: [],
            incStreet: true,
            incPostcode: false,
            incCity: true,
            isBusy: false,
        }
    },
    watch: {
        searchFor() {
            console.log('NewVal:' + this.searchFor);
            if (timer)
                clearTimeout(timer);
            timer = setTimeout(this.search, 400);
        },

    },
    methods: {
        openGoogle() {
            window.open(`https://maps.google.com/?q=${this.searchFor}`,
                "_blank",
                // "toolbar=yes, scrollbars=yes, resizable=yes"
            );
        },
        pasteFromClipboard() {
            navigator.clipboard.readText().then((txt) => {
                //alert(txt);
                var s = txt.split(',');
                try {
                    this.setGeo(Number(s[1]), Number(s[0]))
                    //Clear to avoid repeating
                    navigator.clipboard.writeText('').then(() => {
                        console.log('Clipboard has been cleared.');
                    }).catch(err => {
                        console.error('Failed to clear the clipboard: ', err);
                    });

                } catch (err) {
                    alert('Felaktigt format')
                    return;
                }
            });
        },
        setGeo(x, y) {
            var p = {
                street: this.place.street,
                postcode: this.place.postCode,
                city: this.place.city,
                country: this.place.country,
                geoX: x,
                geoY: y,
            };
            api.post('/api/geo/SetGeoPlace', p).then(res => {
                var geoPlaceId = res.data;
                var evData = { ...p, id: geoPlaceId };
                this.$emit('geocoded', evData);
            });
        },
        search() {
            // Your search logic here
            if (this.searchFor) {
                this.isBusy = true;
                api.get('/api/geo/GeoCodeSearch?q=' + this.searchFor).then(res => {
                    this.placeList = res.data;
                    this.showOnMap(this.placeList);
                    this.isBusy = false;
                });
            }


        },
        showOnMap(places) {
            this.sendMapCommand('clear');
            var markers = places.map(p => {
                return { geoX: p.geoX, geoY: p.geoY, title: p.text, id: p.id, color: '#a886bf' }
            });

            this.sendMapCommand('setmarkers', { markers: markers,events:{click:true} });
            this.sendMapCommand('fitbounds', { markers: markers,events:{click:true} });

        },
        toggleInc(type) {
            switch (type) {
                case 'street':
                    this.incStreet = !this.incStreet;
                    break;
                case 'postcode':
                    this.incPostcode = !this.incPostcode;
                    break;
                case 'city':
                    this.incCity = !this.incCity;
                    break;
            }
            this.searchFor = this.getDefaultSearchFor();
            this.search();
        },
        getDefaultSearchFor() {
            var items = [];
            if (this.incStreet)
                items.push(this.cleanStreet(this.place.street));
            if (this.incPostcode)
                items.push(this.place.postCode);
            if (this.incCity)
                items.push(this.place.city);

            return items.join(',');
        },
        cleanStreet(s) {
            var street = s.split(' LGH')[0];
            return street;
        },
        searchAddress() {

            this.searchFor = street;
            this.search();
        },
        highlightOnMap(p) {
            console.log('TODO:Highligt on map')
            var markers = [{ geoX: p.geoX, geoY: p.geoY, title: p.text, id: p.id }];
            this.sendMapCommand('highlight',{markers:markers});
        },
        handleMessage(ev) {
            //Handle and detect incoming message from iFrame
            var h1 = this.$refs.geocodeiframe;

            if (h1 && h1.contentWindow && ev.source == h1.contentWindow) {
                var cmd = JSON.parse(ev.data);
                //TODO: Handle the message
            }
        },
        sendMapCommand(cmd, data) {
            var h1 = this.$refs.geocodeiframe;
            var cmdJson = JSON.stringify({ cmd: cmd, data: data });
            h1.contentWindow.postMessage(cmdJson, Settings.mapcommandUrl);// 'http://localhost:8080'

        }

    }
}
</script>
